<template>
<div class="content_card_container">
    <img class="teaser_img" :src="mediaPath" alt="teaser image" />
    <img class="content_icon" v-if="item.type == 'contentPDF'" src="@/assets/img/contentLibrary/pdf-icon.png"/>
    <img class="content_icon" v-if="item.type == 'contentArticle'" src="@/assets/img/contentLibrary/video-icon.png"/>
    <img class="content_icon" v-if="item.type == 'contentVideo'" src="@/assets/img/contentLibrary/video-icon.png"/>
    <p class="subheadline">
        {{ item.data.title }}
    </p>
    <p class="teaser_txt">
     {{ item.data.teaser }}
    </p>
    <div class="open_btn" @click="handleOpen">OPEN</div>
</div>
</template>
<script>
export default {
    name: "ContentCard",
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    mounted() {
      console.log("Content Card Item:", this.item);
    },
    methods: {
       handleOpen() {
           console.log("Open content item:", this.item);
           this.$emit('open-content', this.item);
       }
    },
    computed: {
        mediaPath() {
                return app.api.Utils.getMediaPath(this.item.data.displayImage.src);
        }
    }
};
</script>
<style lang="scss" scoped>

.content_card_container {
    position: relative;
    min-width: 316px;
    height: 600px;
}
.content_icon {
    position: absolute;
    bottom: 195px;
    left: -5px;
    z-index: 2;
    background-color: var(--light-grey);
    border-radius: 0 10px 0 0 ;
    padding: 10px;
    
}
.subheadline {
    position: absolute;
    top: 420px;
    font-size: 20px;
    font-weight: 700;
    color: var(--dark-grey);
    text-align: left;
}
.teaser_img{
    width: 100%;
    height: 400px;
    object-fit: cover;
    object-position: center;
    overflow: hidden;
    border-radius: 10px;
}
.teaser_txt {
    position: absolute;
    top: 480px;
    font-size: 15px;
    font-weight: 400;
    color: var(--dark-grey);
    text-align: left;
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}
.open_btn {
    position: absolute;
    bottom: -20px;
    left: 0;
    background-color: var(--dark-green);
    color: var(--white);
    padding: 5px 25px;
    border-radius: 15px;
    cursor: pointer;
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    &:hover {
        background-color: var(--white);
        color: var(--dark-green);
    }
}
</style>